// extracted by mini-css-extract-plugin
export var container = "terms-and-conditions-module--container--fc316";
export var lastText = "terms-and-conditions-module--lastText--9f94c";
export var link = "terms-and-conditions-module--link--dab1d";
export var links = "terms-and-conditions-module--links--44dad";
export var text = "terms-and-conditions-module--text--421e2";
export var textContainer = "terms-and-conditions-module--textContainer--94e67";